import SeamlyCore from './core/seamly-core'
import View from './view'

const ChatApp = (props) => {
  return (
    <SeamlyCore {...props}>
      <View />
    </SeamlyCore>
  )
}

export default ChatApp
